import { render, staticRenderFns } from "./Pitch.vue?vue&type=template&id=3e886058&scoped=true&"
import script from "./Pitch.vue?vue&type=script&lang=js&"
export * from "./Pitch.vue?vue&type=script&lang=js&"
import style0 from "./Pitch.vue?vue&type=style&index=0&id=3e886058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e886058",
  null
  
)

export default component.exports